var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellOutline = function SvgBellOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.556 13.662-1.9-6.836a9.321 9.321 0 0 0-18.08.474l-1.47 6.615A5 5 0 0 0 5.985 20H7.1a5 5 0 0 0 9.8 0h.838a5 5 0 0 0 4.817-6.338M12 22a3 3 0 0 1-2.817-2h5.633A3 3 0 0 1 12 22m8.126-5.185A2.98 2.98 0 0 1 17.737 18H5.988a3.002 3.002 0 0 1-2.929-3.65l1.47-6.617a7.321 7.321 0 0 1 14.2-.372l1.9 6.836a2.98 2.98 0 0 1-.502 2.618"
  })));
};
export default SvgBellOutline;